import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getVisibleItems } from 'resolvers/getVisibleEntities';

/*************************************************************/

/**
 * @type {class}
 * @desc DrugSearch defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DrugSearchService } from 'services/drugSearch';
 *
 * // create service instance and send/cancel request
 * const drugSearchService = new DrugSearchService();
 * const result = await drugSearchService.fetchData( '<user-id>' ); // fetch data
 * drugSearchService.cancel(); // cancel an active request
 */
export class DrugSearchService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract data
            const visibility = get( response, 'body.component.visibility', {} );
            const steps = get( response, 'body.component.structure.steps', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    steps: getVisibleItems( steps, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
